import React, { useEffect } from "react";
import {
  File,
  Undo,
  ArchiveDone,
  Help,
  Home,
  Setting,
} from "react-huge-icons/outline";
import { Whatsapp, Mail } from "react-huge-icons/solid";
import { useNavigate, useLocation } from "react-router-dom";
import "./../../App.css";
import MenuItem from "./menuItem";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../stores/authStore";
import { ConstantRoutes } from "../../core/constantRoutes";
import { ConstantInfo } from "../../core/constantInfo";
import { useWorktimeStore } from "../../stores/worktimeStore";
import useLeftMenuStore from "../../stores/leftMenuStore";
import Dropdown from "../dropdown/dropdown";
import AuthServiceInstance from "../../api/authServices";
import CircularCountdown from "../circularCountdown/circularCountdown";
import { MainLogo } from "../mainLogo";
import EmailInitial from "../common/emailInitial";
import { MainLogoNew } from "../mainLogoNew";
import TechSupportStatus from "./techSupportStatus";
import TechSupportWorkSchedule from "./techSupportWorkSchedule";
import TechSupportAiProcessing from "./techSupportAiProcessing";

function LeftMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (route: string) => {
    setIsOpen(false);
    navigate(route);
  };

  const { t } = useTranslation();

  const { isAuthenticated, authorizedEmail, roles } = useAuthStore();

  const { worktimes, fetchWorktimes } = useWorktimeStore();
  const { isOpen, setIsOpen } = useLeftMenuStore();

  useEffect(() => {
    fetchWorktimes();
  }, []);

  return (
    <div
      className={`flex flex-col h-screen sticky top-0 ${
        isOpen ? "translate-x-0 " : "max-md:-translate-x-full"
      } 
    transition-transform duration-300 ease-in-out md:translate-x-0`}
    >
      <div
        className={`flex-grow bg-content2 rounded-xl overflow-hidden min-h-screen 
        ${
          isOpen ? "lg:w-65 max-lg:w-96" : "max-md:w-0"
        } transition-all duration-300 ease-in-out`}
      >
        <div className="max-md:hidden">
          <MainLogoNew
            mode="light"
            onclickUrl={ConstantRoutes.main}
            w={210}
            h={65}
          />
        </div>

        <div className="border border-solid border-divider" />

        {isAuthenticated() && (
          <div className="p-4">
            <MenuItem
              text={t("File processing")}
              icon={File}
              onClick={() => handleItemClick(ConstantRoutes.fileProcessing)}
              isSelected={location.pathname.startsWith(
                ConstantRoutes.fileProcessing
              )}
            />
            <MenuItem
              text={t("Order history")}
              icon={Undo}
              onClick={() => handleItemClick(ConstantRoutes.orderHistory)}
              isSelected={location.pathname.startsWith(
                ConstantRoutes.orderHistory
              )}
            />

            <MenuItem
              text={t("Home")}
              icon={Home}
              onClick={() => handleItemClick(ConstantRoutes.main)}
              isSelected={location.pathname === ConstantRoutes.main}
            />

            {roles.includes("admin") && (
              <MenuItem
                text={t("Admin panel")}
                icon={Setting}
                onClick={() => handleItemClick(ConstantRoutes.adminUsers)}
                isSelected={location.pathname === ConstantRoutes.adminUsers}
              />
            )}
          </div>
        )}

        <div className="sticky top-[100vh]">
          <div className="border border-solid border-divider" />

          <TechSupportAiProcessing />

          <div className="border border-solid border-divider" />

          <TechSupportWorkSchedule worktimes={worktimes} />

          <div className="border border-solid border-divider" />

          <div className="flex items-center p-4 h-20">
            <a
              href={ConstantInfo.phone}
              className="bg-secondary flex items-center justify-center p-2 rounded-full cursor-pointer hover:bg-primary transition duration-300 ease-in-out w-roundedcontact h-roundedcontact mr-4"
            >
              <Whatsapp className="w-6 h-6" />
            </a>
            <a
              href={ConstantInfo.email + "Other question"}
              className="bg-secondary flex items-center justify-center p-2 rounded-full cursor-pointer hover:bg-primary transition duration-300 ease-in-out w-roundedcontact h-roundedcontact"
            >
              <Mail className="w-6 h-6" />
            </a>
          </div>

          <div className="md:hidden">
            {isAuthenticated() && (
              <div className="p-4">
                <div className="flex items-center bg-content3 p-4 rounded-xl">
                  <EmailInitial email={authorizedEmail} />

                  <Dropdown
                    items={[
                      { id: "profile", label: t("Profile") },
                      { id: "quit", label: t("Exit") },
                    ]}
                    onSelect={function (item: {
                      id: string;
                      label: string;
                    }): void {
                      if (item.id === "quit") {
                        AuthServiceInstance.logout();
                        navigate(ConstantRoutes.main);
                      }
                    }}
                    caption={authorizedEmail ?? "ERROR"}
                    reverseDirection={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeftMenu;
